module.exports = __webpack_public_path__ + "static/media/contact@2x.f883a9e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/contact@2x.png
// module id = ./src/assets/Home/contact@2x.png
// module chunks = 0